import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { legacyPath } from '@platform/navigation';
import { useAppDispatch } from '@platform/state/hooks';
import { workspaceSelected } from '@platform/state/slices/sessionSlice';
import { Spinner } from '@platform/ui';

/**
 * Стара адреса `/w/<простір>/…` (закладки, переспрямування старого домену на app.parliamentarian-office.com/w/…): простір адреси стає
 * поточним у вкладці, далі — та сама сторінка за новою схемою (legacyPath, ADR-028) із заміною запису історії. Простір без доступу
 * оболонка замінить простором входу (WorkspaceLayout).
 */
export function LegacyRedirect() {
  const { ws = '', '*': rest = '' } = useParams();
  const { search, hash } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (ws) dispatch(workspaceSelected(ws));
    navigate(`${legacyPath(rest, search)}${hash}`, { replace: true });
  }, [ws, rest, search, hash, dispatch, navigate]);
  return <div className="login"><Spinner /></div>;
}
